const env = process.env.VUE_APP_BUILD_ENV
const BD_URL = new Map([
  ['pro', 'https://hm.baidu.com/hm.js?8c63217164cf7d6a8c5b3f004e2576d7'],
  ['test', 'https://hm.baidu.com/hm.js?77010b36709b86bea3059c5d069df55e']
])
export default {
  install() {
    window._hmt = window._hmt || [] // 修改为window 全局变量
    ;(function() {
      var hm = document.createElement('script')
      hm.src = BD_URL.get(env)
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
      var meta = document.createElement('meta')
      meta.content = 'no-referrer'
      meta.name = 'referrer'
      document.getElementsByTagName('head')[0].appendChild(meta)
    })()
  }
}
